export const UPDATE_TRACKERS    = 10001;
export const UPDATE_REPORTS     = 10002;
export const CHANGE_MAP_CENTER  = 10003;
export const CHANGE_TRACKER     = 10004;
